import "../common.scss";

export default function Footer() {
  const CONTACT_CJ = "Chris Rallos (123) 456-7890";
  const CONTACT_EMD = "Ella Diaz (123) 456-7890";

  return (
    <div
      id="footer"
      className="footer position-relative display-flex flex-column padding-top-3 padding-bottom-3"
    >
      <div className="display-flex flex-column justify-center align-center text-center">
        <p className="cormorant-light-400 padding-3 letter-spacing-2 font-size-4">
          CONTACT US
        </p>
        <p className="cormorant-light-400 padding-2 letter-spacing-1 font-size-4">
          placeholder@gmail.com
        </p>

        <p className="cormorant-light-400 letter-spacing-1 font-size-4">
          {CONTACT_CJ}
        </p>
        <p className="cormorant-light-400 letter-spacing-1 font-size-4">
          {CONTACT_EMD}
        </p>
      </div>
      <div className="display-flex flex-row justify-content-between width-100">
        <p className="credits cormorant-light-400">2025 EMD DESIGNS</p>
        <p className="credits cormorant-light-400">
          Website by{" "}
          <a
            className="cormorant-light-400 text-dark underline"
            href="https://jmdiaz.dev/"
          >
            jmdiaz.dev
          </a>
        </p>
      </div>
    </div>
  );
}
